import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  useAuthUserRestaurant,
  useGetRestaurantCompanyEmployeesQuery,
} from '@durma-soft/gros-sdk';

import { CompanyEmployeesPage } from '@/components/restaurant/companies/company-employees-page';

import { useTableSearchParams } from '@/hooks/use-table-search-params';

const RestaurantCompanyEmployees = () => {
  const { t } = useTranslation();
  const { companyId, employeeId } = useParams();

  if (!companyId) {
    throw new Error('Company ID is required getting employees');
  }

  const restaurant = useAuthUserRestaurant();
  const state = useTableSearchParams({ prefix: 'e_' });

  const query = useGetRestaurantCompanyEmployeesQuery({
    restaurant_id: restaurant.id,
    company_id: Number(companyId),
    q: state.debouncedSearchInput,
    page: state.pagination.pageIndex + 1,
    page_size: state.pagination.pageSize,
    sort_by: state.sorting[0]?.id,
    sort_order: state.sorting[0]?.desc ? 'desc' : 'asc',
  });

  return (
    <CompanyEmployeesPage
      companyId={Number(companyId)}
      employeeId={employeeId}
      breadcrumbItems={[
        {
          label: t('employee.title'),
          to: `/restaurant/companies/${companyId}/employees`,
        },
      ]}
      createTo={`/restaurant/companies/${companyId}/employees/create`}
      importTo={`/restaurant/companies/${companyId}/employees/import`}
      query={query}
      state={state}
    />
  );
};

export default RestaurantCompanyEmployees;
